import React from 'react';

import TireWheelPackageStatusItem from './components/tire-wheel-package-status-item/tire-wheel-package-status-item';
import {
  PACKAGE_STATUS,
  STEP_TYPE
} from './tire-wheel-package-status-constants';

import { useTireWheelPackage } from '../../shared/hooks/hooks';

import './tire-wheel-package-status.scss';

function TireWheelPackageStatus() {
  const { completedPackageType, currentTireWheelPackageFlow } =
    useTireWheelPackage();

  function getStatus(step) {
    if (completedPackageType) {
      return PACKAGE_STATUS.COMPLETED;
    } else if (currentTireWheelPackageFlow?.step === step) {
      return PACKAGE_STATUS.IN_PROGRESS;
    } else if (currentTireWheelPackageFlow?.step > step) {
      return PACKAGE_STATUS.COMPLETED;
    } else {
      return PACKAGE_STATUS.NOT_STARTED;
    }
  }

  const steps = [
    {
      count: 1,
      status: getStatus(0),
      type: completedPackageType ?? currentTireWheelPackageFlow?.type
    },
    {
      count: 2,
      status: getStatus(1),
      type:
        (completedPackageType ?? currentTireWheelPackageFlow?.type) ===
        STEP_TYPE.WHEELS
          ? STEP_TYPE.TIRES
          : STEP_TYPE.WHEELS
    },
    {
      count: 3,
      status: getStatus(2),
      type: STEP_TYPE.FINALIZE
    }
  ];

  return (
    <div className="tire-wheel-package-status" styleName="container">
      {steps.map(step => (
        <TireWheelPackageStatusItem
          count={step.count}
          key={step.type}
          status={step.status}
          type={step.type}
        />
      ))}
    </div>
  );
}

export default TireWheelPackageStatus;
